import React from 'react';
import { Button } from 'is24-corecss';

type AddTeamMemberButtonProps = {
  onAddTeamMember?: () => void;
};

const AddTeamMemberButton: React.FC<AddTeamMemberButtonProps> = ({ onAddTeamMember }: AddTeamMemberButtonProps) => {
  return (
    <div className='padding-bottom-s'>
      <Button data-testid='add-team-members' appearance='primary' className='margin-bottom-l' onClick={onAddTeamMember}>
        <span className='is24-icon-add button-icon-margin-right' />
        Teammitglied hinzufügen
      </Button>
    </div>
  );
};

export default AddTeamMemberButton;
